import React from 'react';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import useTheme from '@material-ui/core/styles/useTheme';
import Skeleton, {
  SkeletonProps as MuiSkeletonProps,
} from '@material-ui/lab/Skeleton';

export type SkeletonTypographyProps = {
  loaded?: boolean,
  width?: number | string,
  fontSize?: number | string,
  lineHeight?: number | string,
  SkeletonProps?: Omit<MuiSkeletonProps, 'variant'>,
} & TypographyProps;

const SkeletonTypography = ({
  loaded,
  width = '100%',
  fontSize,
  lineHeight,
  variant,
  align,
  SkeletonProps,
  ...props
}: SkeletonTypographyProps) => {
  const theme = useTheme();

  const themeVariant = theme.typography[variant] || theme.typography.body1;

  const fs =
    typeof fontSize === 'number'
      ? theme.typography.pxToRem(fontSize)
      : themeVariant.fontSize;

  const lh = lineHeight || themeVariant.lineHeight;

  if (loaded) {
    return (
      <Typography
        variant={variant}
        align={align}
        {...props}
        style={{ ...props.style, fontSize: fs, lineHeight: lh }}
      />
    );
  } else {
    const marginLeft = ['right', 'center'].includes(align) ? 'auto' : 0;

    const marginRight = ['left', 'center'].includes(align) ? 'auto' : 0;

    return (
      <Skeleton
        variant="text"
        {...SkeletonProps}
        style={{
          width,
          height: `calc(${fs} * ${lh})`,
          marginLeft,
          marginRight,
          ...(SkeletonProps?.style || {}),
        }}
      />
    );
  }
};

export default SkeletonTypography;
